import { sprintf } from 'sprintf-js'

/**
 * Marks strings for translation but doesn’t translate them now.
 * This can be used to store strings in global variables and functions
 * that should stay in the base language (because they might be used externally)
 * and will be translated later.
 */
export const $t_noop = (msgid, formatting) => { // eslint-disable-line camelcase
  let message = msgid
  if (formatting) {
    message = sprintf(message, formatting)
  }
  return message
}

export const $ngettext_noop = (msgid, plural, count) => { // eslint-disable-line camelcase
  return msgid
}

export const toLocaleISOCode = (languageCode) => {
  return languageCode.split('-').map((v, i) => i > 0 ? v.toUpperCase() : v).join('_')
}

export const getFallbackLocale = (languageCode) => {
  const parts = languageCode.split('_')
  return parts.length > 1 ? parts[0] : null
}
